
import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye, UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import { JobSearchResult } from '@/types/jobSearch';

interface JobCardFooterActionsProps {
  job: JobSearchResult;
  isUserLoggedIn: boolean;
  isProcessingAction: boolean; // Combined from isSavingThisJob or any other processing state
  onViewDetails: () => void;
  onMakeLead: (job: JobSearchResult) => void;
}

export const JobCardFooterActions: React.FC<JobCardFooterActionsProps> = ({
  job,
  isUserLoggedIn,
  isProcessingAction,
  onViewDetails,
  onMakeLead,
}) => {
  const handleMakeLeadClick = () => {
    if (!isUserLoggedIn) {
      toast.error("Please log in to create leads.");
      return;
    }
    onMakeLead(job);
  };

  return (
    <div className="flex justify-end space-x-2">
      <Button
        size="sm"
        variant="ghost"
        onClick={onViewDetails}
        aria-label={`View details for ${job.title || job.job_title}`}
      >
        <Eye className="mr-2 h-4 w-4" />
        View Details
      </Button>
      <Button
        size="sm"
        variant="default"
        onClick={handleMakeLeadClick}
        disabled={isProcessingAction}
        aria-label={`Make lead from ${job.title || job.job_title}`}
      >
        <UserPlus className="mr-2 h-4 w-4" />
        Make Lead
      </Button>
    </div>
  );
};
